import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { LanguageProvider } from "./study/i18n";
import App from "./study/RankStudyPage";
import ReviewPage from "./study/ReviewPage";

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>{location.pathname === "/review" ? <ReviewPage /> : <App />}</LanguageProvider>
    </BrowserRouter>
  </StrictMode>,
);
